export default __webpack_public_path__ + "static/media/fabCover.c03821a1.jpg";